import { palette } from 'assets/styles/colors';

const formControlLabel = {
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        backgroundcolor: `${palette.cactus[500]}`,
      },
    },
  },
};

export default formControlLabel;
